import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../hooks/hooks';
import type { JSX } from 'react';

interface ProtectedRouteProps {
  children: JSX.Element;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const user = useAppSelector((state) => state.auth.user);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
